import {required, email, sameAs} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core/dist/index.esm";
import {mixins} from "../app/mixin";

const fileSizeValidation = (value, vm) => {
    if (!value) {
        return true
    }
    const file = value
    return file.size < 2097153
}

const fileTypeValidation = (value, vm) => {
    if (!value) {
        return true
    }
    const fileName = value.name
    const pattern = /\.(pdf|docx|doc)$/
    return pattern.test(fileName)
}

mixins.push({
    el: '.internship',
    delimiters: ['${', '}'],
    validations: {
        fullName: {required},
        city: {required},
        province: {required},
        phone: {required},
        email: {required, email},
        isKVKKApproved: {required, sameAs: sameAs(true)},
        coverLetter: {required},
        cvFile: {required, fileSizeValidation, fileTypeValidation},
        department: {required},
    },
    data: () => ({
        v: useVuelidate(),
        API: window.api,
        fullName: '',
        email: '',
        phone: '',
        city: 34,
        province: '',
        isKVKKApproved: false,
        cvFile: null,
        coverLetter: '',
        department: '',
        provinceList: [],
        status: '',
        lang: window.lang,
        siteKey: window.siteKey
    }),
    computed: {
        //todo locale
        errorMessage() {
            let errorMessage = ''
            if (!this.v.cvFile.fileSizeValidation) {
                errorMessage = "File size cannot exceed 2MB"
            }
            if (!this.v.cvFile.fileTypeValidation) {
                errorMessage = 'File type must be .pdf, .doc or .docx'
            }
            return errorMessage
        },
    },
    async mounted() {
        await this.loadDistricts();
    },
    methods: {
        setCv(e) {
            this.$emit('input', e.target.files[0])
            this.cvFile = this.$refs.cv.files[0]
            this.v.cvFile.$touch()
        },
        async loadDistricts() {
            this.provinceList = [];

            const response = await fetch(`${this.API}/location/districts?city.id=${this.city}`, {
                method: "GET",
            });

            const json = await response.json();

            this.provinceList = json['hydra:member'];

            this.v.city.$touch();
        },
        uploadCv: async function (applicationId) {
            try {
                const recaptchaToken = await grecaptcha.execute(this.siteKey, {action: 'submit'});
                const requestData = new FormData();
                requestData.append('cvFile', this.cvFile, 'cvFile');
                requestData.append('recaptchaToken', recaptchaToken);

                const uploadResponse = await fetch(`${this.API}/internship-applications/${applicationId}/upload-cv`, {
                    method: "POST",
                    body: requestData
                });

                if (uploadResponse.status === 201) {
                    this.resetForm();
                    this.status = 'SUCCESS';
                } else {
                    throw 'CV upload error';
                }
            } catch (error) {
                console.log('CV upload error:', error);
                this.status = 'ERROR';
            } finally {
                setTimeout(() => {
                    this.status = '';
                }, 15000);
            }
        },
        async sendApplication() {
            this.v.$touch();
            this.v.$validate();

            if (!this.v.$invalid && this.isKVKKApproved) {
                try {
                    const recaptchaToken = await grecaptcha.execute(this.siteKey, {action: 'submit'});
                    const requestObject = {
                        fullName: this.fullName,
                        email: this.email,
                        phone: this.phone.toString(),
                        district: this.province,
                        department: this.department,
                        message: this.coverLetter,
                        recaptchaToken: recaptchaToken
                    };

                    const response = await fetch(`${this.API}/internship-applications`, {
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': this.lang
                        },
                        body: JSON.stringify(requestObject)
                    });

                    if (response.status === 201) {
                        const data = await response.json();
                        await this.uploadCv(data.id);
                    } else {
                        console.log('Application error:', response.status, response);
                        throw 'application error';
                    }
                } catch (error) {
                    this.status = 'ERROR';
                    setTimeout(() => {
                        this.status = '';
                    }, 15000);
                }
            }
        },
        resetForm() {
            this.cvFile = '';
            this.fullName = '';
            this.email = '';
            this.phone = '';
            this.province = '';
            this.coverLetter = '';
            this.jobId = '';
            this.applicationType = '';
            this.isKVKKApproved = false;
            this.department = '';
            this.v.$reset();
        },
        goToForm() {
            const fullNameElem = document.getElementById('fullName')
            fullNameElem.focus()
        },
    },
});